export class GetRestoreAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
